<script setup lang="ts">
defineProps<{
  value: boolean
}>()
</script>

<template>
  <i :class="'fas fa-check-circle mr-2 ' + (value ? 'text-success' : 'text-danger')" />
</template>
